<template>
  <img
    :src="fullSrc"
    :style="imageStyle"
    :alt="alt"
    :class="[isNoData ? 'jd-no-data-img' : '', 'normal-img']"
  />
</template>
<script>
export default {
  name: "jdImage",
  props: {
    src: {
      type: String,
      default: "",
    },
    isNoData: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: "",
    },
    height: {
      type: [String, Number],
      default: "",
    },
    customStyle: {
      type: Object,
      default: () => ({}),
    },
    alt: {
      type: String,
      default: "",
    },
  },
  computed: {
    fullSrc() {
      if (this.src.startsWith("http")) {
        return this.src;
      }
      return this.$globalCdn + this.src;
    },
    imageStyle() {
      const defaultStyle = {};
      if (this.isNoData) {
        defaultStyle.width = this.width || "210px";
        defaultStyle.height = this.height || "138.4px";
      } else {
        if (this.width) {
          defaultStyle.width =
            typeof this.width === "number" ? `${this.width}px` : this.width;
        }
        if (this.height) {
          defaultStyle.height =
            typeof this.height === "number" ? `${this.height}px` : this.height;
        }
      }
      return { ...defaultStyle, ...this.customStyle };
    },
  },
};
</script>
<style lang="scss" scoped>
.jd-no-data-img {
  display: block;
  margin: 0 auto;
}
.normal-img {
  display: block;
  margin: 0 auto;
  width: 157px;
  height: 100px;
}
</style>